// extracted by mini-css-extract-plugin
export default {"cls1":"Link-cls1__0E","cls2":"Link-cls2_xBF Link-cls1__0E"};